import { action, observable, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'
import { message } from 'hljd'
import AlreadyStore from './Tabs/Already/store'
import RecordStore from './Tabs/Record/store'
import WaitStore from './Tabs/Wait/store'
import { getMerchantInfo } from '@util'
import { getMomentTime } from '@hlj/hlj-utils'

class Store {
  /**
   * 旧功能：有些方法已不再调用，暂时没删
   */
  @observable point = 0
  @observable all_points = []
  @observable hot = []
  @observable unit_price = 1
  @observable is_valid = false
  @observable title = ''

  @observable active = 0
  @observable per_point = 10
  @action
  doCheckClick = (index, item) => () => {
    this.active = index
    this.per_point = item
  }

  @observable loading = false
  @action
  getPoint = async () => {
    this.loading = true
    let {
      data: { balance, all_points, hot, unit_price, is_valid, tip }
    } = await Api.point()
    runInAction(() => {
      this.point = balance
      this.all_points = all_points
      this.hot = hot
      this.unit_price = unit_price
      this.is_valid = is_valid
      this.title = (tip && tip.title) || ''
      this.loading = false
    })
  }

  @observable visible = false
  @action
  showModal = () => {
    this.visible = true
  }

  @action
  hideModal = () => {
    this.visible = false
    this.valid_code_post = ''
  }

  @observable valid_code_post = ''
  @action
  changeCode = e => {
    this.valid_code_post = e.target.value
  }

  @action
  checkCode = async () => {
    const { valid_code_post } = this
    const { id } = getMerchantInfo()

    let { success } = await Api.check_in({ valid_code_post, id })
    if (success) {
      message.success('操作成功')
      this.hideModal()
    }
  }

  @observable show = false
  @action
  doApply = () => {
    this.show = true
  }

  @action
  closeApply = () => {
    this.show = false
  }

  /**
   * 新增功能： 创建报名活动
   */
  @observable infoModalVisible = false
  @observable listModalVisible = false
  @observable coverModalVisible = false
  @observable imgs = []
  @observable activeTab = '1'
  @observable finderId = ''
  @observable wallet = {}
  @observable selectedActivity = {}

  @action
  changeTab = key => {
    this.activeTab = key
    if (key == '1') {
      AlreadyStore.getList()
    } else if (key == '2') {
      WaitStore.getList()
    } else if (key == '3') {
      RecordStore.getList()
    }
  }
  @action
  changeSelectActivity = item => {
    this.selectedActivity = item
  }
  @action
  positionActiveTab = key => {
    this.activeTab = key
    if (key == '1') {
      AlreadyStore.getList()
    } else if (key == '2') {
      WaitStore.getList()
    } else if (key == '3') {
      RecordStore.getList()
    }
  }
  @action
  initModalVisible = () => {
    this.listModalVisible = false
    this.coverModalVisible = false
  }
  @action
  operateModal = (type, extra) => () => {
    this[type] = !this[type]
    if (extra) {
      this[extra] = !this[extra]
    }
  }
  createFinderActivity = async values => {
    const {
      selectedActivity: { id },
      imgs
    } = this
    if (!id) return message.warning('请选择活动')
    if (imgs.length < 4) {
      return message.warn('至少上传4张活动资源图')
    }
    if (imgs.length > 15) {
      return message.warn('图片素材不可多于15张')
    }

    const { success, msg } = await Api.createFinderActivity({
      ids: id,
      imgs,
      start_date: getMomentTime(values['time'], 0, __FMT2__),
      end_date: getMomentTime(values['time'], 1, __FMT2__)
    })
    if (!success) {
      return message.warning(msg)
    }
    this.initModalVisible()
    this.positionActiveTab('3')
  }
  @action
  showCoverModal = () => {
    if (!this.selectedActivity.id) return message.warning('请选择活动')
    this.coverModalVisible = !this.coverModalVisible
  }
  @action
  cancelCoverModal = () => {
    this.coverModalVisible = !this.coverModalVisible
  }

  @action
  uploaded = (link, file) => {
    const { width, height } = file
    this.imgs.push({
      width,
      height,
      img: link
    })
  }

  @action
  removeImg = index => {
    this.imgs = this.imgs.filter((item, i) => index !== i)
  }

  @action
  getWallet = async () => {
    const { success, data } = await Api.getWallet()
    if (success) {
      this.wallet = data || {}
    }
  }
}
export default new Store()
